module.exports = __webpack_public_path__ + "static/media/e-citizen_Nigeria_Terms_of_Service_v2.1_Confirmed.64e8647e.pdf";